import styled from 'styled-components'
import useSWR from 'swr'
import usePageContext from '../../Page/context'
import { APIGetMedallists } from '../../../endpoints'
import { FC, useState } from 'react'
import Link from 'next/link'
import MedalistsTitle from '../MedalistsTitle'


const ModuleMedallistsPhase3 = (props: any) => {
  const {
    state: { getEnvConfig }
  } = usePageContext()
  const { data } = useSWR(`${getEnvConfig.NEXT_CMS}${APIGetMedallists()}`)

  return (
    <StyledComponent className='px-0'>
      <div className='snap-section-start theme-black show-floating-logos relative top-[10px]' />
      {/* Make a 12 column grid with Tailwind */}
      <div className='wrapper'>
        <MedalistsTitle title={props.medallistBlockHeading} brief={props.medallistBlockHeadingBrief} />
        <div className='grid grid-cols-3 md:grid-cols-3 lg:grid-cols-6 px-[30px]'>
          {data?.data.map((item: any) => (
            <Link
              key={item.id}
              href={`/medalist/${item.id}`}
            >
              <MedalistSquare key={item.id} name={item.attributes.name} $medalistImage={item.attributes.medallistPhaseTwoDotFiveImage?.data?.attributes?.url} />
            </Link>
          ))}
        </div>
      </div>
    </StyledComponent>
  )
}

// {`font-abcd uppercase text-[8px] ${visible ? '' : 'invisible'}

const MedalistSquare: FC<IMedalistUI> = ({ name, ...props }) => {
  const [visible, setVisible] = useState(false)
  return (
    <StyledMedallistSquare
      onMouseOver={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      {...props}
    >
      {/* <div className='image' /> */}
      <img src={props.$medalistImage} alt={name} className='image' />
      <div className={`font-abcd uppercase text-[8px] ${visible ? '' : 'invisible'}`}>{name}</div>
    </StyledMedallistSquare>)
}

const StyledComponent = styled.div<any>`
  scroll-snap-align: start;
  > div.wrapper {
    height: 100vh;
    justify-content: center;
    margin: 0 auto;
    align-items: center;
  }
`

const StyledMedallistSquare = styled.div<any>`
  position: relative;
  margin: 0 auto;
  text-align: center;
  width: 100%;

  // div.image {
  //   background-image: url(${(props) => props.$medalistImage});
  //   width: 72px;
  //   height: 209px;
  //   margin: 0 auto 10px auto;
  // }

  img.image {
    width: 100%;
    margin: 0 auto;
  }

  div.name {
    text-align: center;
  }
`

interface IMedalistUI {
  name: string
  $medalistImage: string
}

export default ModuleMedallistsPhase3